import { useSyncExternalStore } from "react";
import { shouldHideSubscriptions } from "../utils/platform";

const NATIVE_EVENT = "nativePushToken";
const listeners = new Set<() => void>();

const subscribe = (onStoreChange: () => void) => {
  listeners.add(onStoreChange);
  if (typeof window !== "undefined") {
    window.addEventListener(NATIVE_EVENT, onStoreChange);
    window.addEventListener("resize", onStoreChange);
  }
  return () => {
    listeners.delete(onStoreChange);
    if (typeof window !== "undefined") {
      window.removeEventListener(NATIVE_EVENT, onStoreChange);
      window.removeEventListener("resize", onStoreChange);
    }
  };
};

const getSnapshot = () => shouldHideSubscriptions();
const getServerSnapshot = () => false;

/** True only on iPhone-sized iOS, where web checkout is hidden. */
export const useShouldHideSubscriptions = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
